import { BookingItemInterface } from 'Models/UI/BookingItemInterface';
import { TS_Offer } from '../TravelSeller/Models/TS_Offer';

export class Offer extends TS_Offer implements BookingItemInterface {
}